import { action, thunk } from 'easy-peasy'
import { admin, dashboard } from '../../../api'

export const mainAdmin = {
	admin: null,
	admins: [],
	roles: [],
	adminStat: {
		stat1: 0,
		stat2: 0,
		stat3: 0,
		stat4: 0,
	},
	adminOperator: {
		ope1: 0,
		ope2: 0,
		ope3: 0,
	},
	setAdmin: action((state, admin) => {
		state.admin = admin
	}),
	setAdmins: action((state, admins) => {
		state.admins = admins
	}),
	setRoles: action((state, roles) => {
		state.roles = roles
	}),
	setAdminStat: action((state, stat) => {
		state.adminStat = stat
	}),
	setAdminOperator: action((state, stat) => {
		state.adminOperator = stat
	}),
	signin: thunk(async (actions, { username, password }) => {
		const res = await admin.signin(username, password, 3)
		if (res && res.status === 200) {
			actions.setAdmin(res.data)
		}
	}),
	getAdmins: thunk(async actions => {
		const res = await admin.getAdmins()
		if (res && res.status === 200) {
			actions.setAdmins(res.data)
		}
	}),
	createAdmin: thunk(async (actions, payload) => {
		const { adminRoleID, email, firstname, lastname, adminStatusID } = payload
		const res = await admin.addAdmin(adminRoleID, email, firstname, lastname, adminStatusID)
		if (res && res.status === 200) {
			actions.getAdmins()
			return true
		}
		return false
	}),
	updateAdmin: thunk(async (actions, payload) => {
		const { adminID, adminRoleID, email, firstname, lastname, adminStatusID } = payload
		const res = await admin.editAdmin(
			adminID,
			adminRoleID,
			email,
			firstname,
			lastname,
			adminStatusID
		)
		if (res && res.status === 200) {
			actions.getAdmins()
			return true
		}
		return false
	}),
	removeAdmin: thunk(async (actions, adminID) => {
		const res = await admin.deleteAdmin(adminID)
		if (res && res.status === 200) {
			actions.getAdmins()
			return true
		}
		return false
	}),
	getRoles: thunk(async actions => {
		const res = await admin.getAdminRoles()
		if (res && res.status === 200) {
			actions.setRoles(res.data)
		}
	}),
	getAdminDashboardStat: thunk(async actions => {
		const res = await dashboard.getDashboardStat()
		if (res && res.status === 200) {
			const { data, ope } = res.data

			actions.setAdminStat(data)
			actions.setAdminOperator(ope)
		}
	}),
}
